import { useEffect, useState } from "react";
import { Platform, useWindowDimensions } from "react-native";

export const useDevice = () => {
  const { width, height } = useWindowDimensions();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const isPortrait = height >= width;
  const isLandscape = width > height;
  const isCompactLandscape = isLandscape && width <= 900 && height <= 520;

  const isWeb = Platform.OS === "web";
  const isIOS = Platform.OS === "ios";
  const isAndroid = Platform.OS === "android";
  const isNative = isIOS || isAndroid;

  // Define breakpoints
  const isXs = width < 600;
  const isSm = width >= 600 && width < 768;
  const isMd = width >= 768 && width < 1200;
  const isLg = width >= 1200 && width < 1660;
  const isXLg = width >= 1660;
  const isTablet = width >= 768 && width < 980;
  const isMedium = width > 980 && width < 1200;
  const isDesktop = isWeb && (isLg || isMd || isXLg) && !isPortrait;
  // const isTablet = !isXs && (isSm || isMd);
  const isMobile = isNative || ((isXs || isSm) && isPortrait);

  return {
    isClient,
    width,
    height,
    isPortrait,
    isMobile,
    isXs,
    isSm,
    isMd,
    isLg,
    isXLg,
    isDesktop,
    isTablet,
    isMedium,
    isLandscape,
    isNative,
  };
};
